import React from 'react';
import Head from 'next/head';
import Login from '../components/Auth/Login';
import { withTranslation } from 'next-i18next';
import GuestConstraintRoute from '../RouteConstraint/GuestConstraint';
import { serverSideTranslations } from '@lib/i18n';
import { TFunction } from 'i18next';

interface LoginWrapperProps {
  t: TFunction;
}

const LoginWrapper = (props: LoginWrapperProps) => {
  const { t } = props;
  return (
    <div className="bg-light-gray">
      <Head>
        <title>{t('title.login')}</title>
        <meta name="description" content={t('description.login')} />
      </Head>
      <div className="px-4 sm:px-6 lg:px-8 pt-6 pb-8 md:pt-12 md:pb-16">
        <Login {...(props as any)} />
      </div>
    </div>
  );
};

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      // Will be passed to the page component as props
    },
  };
}

export default GuestConstraintRoute(withTranslation('common')(LoginWrapper));
